export default __webpack_public_path__ + "static/news_default-b5e05555d774b5b4a0ced6e5066bd9d8.jpg";